import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmModalData } from './confirm-modal.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PopupButtonAction } from './popup-button-action.enum';
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements OnInit {

  warningMessage: string = "";
  title: string = "";
  question: string = "";
  confirm: string = "";
  confirmCssStyle: string = "";
  @Output() confirmed = new EventEmitter<string>();

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModalData) {
    this.warningMessage = data.warningMessage;
    this.title = data.title;
    this.question = data.question;
    this.confirm = data.confirm;
    this.confirmCssStyle = data.confirmCssStyle;
  }

  onNoClick(): void {
    this.dialogRef.close({ data: PopupButtonAction.BACK });
  }
  ngOnInit(): void { }

  onSubmitClick() {
    this.dialogRef.close({ data: PopupButtonAction.SUBMIT });
  }
}
